import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { InternalService } from "./internal.service";
import { AuthService } from "./auth.service";
/**
 * Servicio para operaciones generales de la plataforma Imadata.
 * Extiende InternalService para heredar manejo de errores y utilidades comunes.
 */
@Injectable()
export class ImadataService extends InternalService {
    /**
     * Constructor: inyecta dependencias necesarias.
     */
    constructor(http: HttpClient, router: Router, authService: AuthService) {
        super(http, router, authService);
    }

    /**
     * Envía un reporte usando FormData al endpoint de reportes.
     * @param formData FormData con los datos y archivos a enviar.
     * @returns Observable con la respuesta del backend.
     */
    ReportSender(formData: FormData): Observable<any> {
        // Obtiene el token de autenticación
        let token = localStorage.getItem('token');
        if (token) token = JSON.parse(token);

        const headers = new HttpHeaders().set('Authorization', 'Bearer ' + (token || ''));

        // Envía el FormData al backend
        return this.http
            .post(`${environment.apiUrl}/report/report-sender/`, formData, { headers })
            .pipe(catchError(this.handleError.bind(this)));
    }
}